import { toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "kpi-name-popover-text"
};
const _hoisted_2 = {
  class: "input-icon"
};
const _hoisted_3 = {
  key: 1
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_a_button = _resolveComponent("a-button");
  const _component_a_space_compact = _resolveComponent("a-space-compact");
  const _component_edit_outlined = _resolveComponent("edit-outlined");
  const _component_a_popover = _resolveComponent("a-popover");
  return $props.editMode ? (_openBlock(), _createElementBlock("span", _hoisted_1, [_createTextVNode(_toDisplayString($props.label) + " ", 1), _createElementVNode("span", _hoisted_2, [$props.popover ? (_openBlock(), _createBlock(_component_a_popover, {
    key: 0,
    placement: "bottomLeft"
  }, {
    content: _withCtx(() => [_createVNode(_component_a_space_compact, {
      block: ""
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.actions, (item, idx) => {
        return _openBlock(), _createBlock(_component_a_button, {
          key: idx,
          type: item.type,
          danger: item.danger,
          icon: item.icon,
          onClick: item.action
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(item.title), 1)]),
          _: 2
        }, 1032, ["type", "danger", "icon", "onClick"]);
      }), 128))]),
      _: 1
    })]),
    default: _withCtx(() => [_createElementVNode("a", {
      onClick: _cache[0] || (_cache[0] = (...args) => $setup.handleEdit && $setup.handleEdit(...args))
    }, [_createVNode(_component_edit_outlined)])]),
    _: 1
  })) : (_openBlock(), _createElementBlock("a", {
    key: 1,
    type: "link",
    onClick: _cache[1] || (_cache[1] = (...args) => $setup.handleEdit && $setup.handleEdit(...args))
  }, [_createVNode(_component_edit_outlined)]))])])) : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString($props.label), 1));
}